import { useEffect, useState } from "react";
import DataGrid from 'react-data-grid';
import { formatDateToUtc, NoRecordFound } from "../commonfunction";


interface Revision {
    revisionInternalId: number;
    revisionDisplayId: number;
    revisionDate: string;
}

interface RevisionInformation {
    latestRevision: Revision;
    numberOfRevisions: number;
    revisions: Revision[];
}

interface RevisionNoteProps {
    revisionInformation?: RevisionInformation;
    isLocked: boolean;
}

const RevisionNote: React.FC<RevisionNoteProps> = ({ revisionInformation, isLocked }) => {
    
    const [revisionNoteColumns, setRevisionNoteColumns] = useState<any[]>([]);
    const [revisionNoteRows, setRevisionNoteRows] = useState<any[]>([]);
    const [toggleRevisionNote, setToggleRevisionNote] = useState<boolean>(false);

    useEffect(() => {
        setToggleRevisionNote(false);
        setRevisionNoteColumns([
            {
                key: "revisionDisplayId",
                name: "Revision #",
                headerRenderer: () => (
                    <div style={{ color: '#7F96A5' }}>
                        Revision #
                    </div>
                )
            },
            {
                key: "revisionDate",
                name: "Date",
                headerRenderer: () => (
                    <div style={{ color: '#7F96A5' }}>
                        Date
                    </div>
                )
            }
        ]);

        if (revisionInformation?.revisions?.length) {
            setRevisionNoteRows(
                revisionInformation.revisions.map((rev) => ({
                    revisionDisplayId: rev.revisionDisplayId,
                    revisionDate: formatDateToUtc(rev.revisionDate, 'MM/DD/YYYY hh:mm:ss')
                }))
            );
        } else {
            setRevisionNoteRows([]);
        }
    }, [revisionInformation]);
    
    const handleToggleRevisionNote = () => {
        if (!isLocked) {
            setToggleRevisionNote((prev) => !prev);
        }
    };
        
    return (
        <>
            <div
                className={
                    isLocked
                        ? 'realted_document locked-screen'
                        : 'realted_document'
                }
            >
                <div
                    className={
                        toggleRevisionNote
                            ? 'with-bg-recent header_row d-flex align-items-stretch justify-content-between'
                            : 'header_row d-flex align-items-stretch justify-content-between no-bg-recent'
                    }
                    onClick={() =>
                        isLocked
                            ? null
                            : handleToggleRevisionNote()
                    }
                >
                    <div className='header_title'>
                        <i
                            className='fa-solid fa-files'
                            aria-hidden='true'
                        />
                        Revision {revisionInformation?.latestRevision?.revisionDisplayId ?? 0} of {revisionInformation?.numberOfRevisions ?? 0}
                        {revisionInformation?.latestRevision?.revisionDate && (
                            <span style={{
                                marginLeft: "8px",
                                fontSize: '10px',
                                fontWeight: 'normal' 
                            }}>
                                Latest: {formatDateToUtc(revisionInformation.latestRevision.revisionDate)}
                            </span>
                        )}
                        
                    </div>
                    <div
                        className='dropdown_icon'
                        onClick={() =>
                            isLocked
                                ? null
                                : handleToggleRevisionNote()
                        }
                    >
                        <i
                            title={
                                toggleRevisionNote
                                    ? 'Close'
                                    : 'Open'
                            }
                            className={
                                toggleRevisionNote
                                    ? 'fa-regular fa-chevron-up'
                                    : 'fa-regular fa-chevron-down'
                            }
                            aria-hidden='true'
                        />
                    </div>
                </div>
                <>
                    <div
                        className={
                            toggleRevisionNote
                                ? 'open-recent-doc'
                                : 'close-recent-doc'
                        }
                    >
                        <div className='no-first-col'>
                            <div className='grid_table'
                                style={{
                                    borderRight: '50px',
                                    overflowY: 'auto',
                                }}
                            >
                                <>
                                    <DataGrid
                                        columns={revisionNoteColumns}
                                        rows={revisionNoteRows}
                                        rowHeight={52}
                                        rowKeyGetter={(row) => {
                                            return row.id;
                                        }}
                                        emptyRowsRenderer={NoRecordFound}
                                        style={{
                                            height: `${Math.min(
                                                52 + (revisionNoteRows.length > 0 ? revisionNoteRows.length * 52 : 60),
                                                364
                                            )
                                                }px`,
                                        }}
                                        className='related-doc-grid'
                                    />
                                </>
                            </div>
                        </div>
                    </div>
                </>
            </div>
        </>
    );
}

export default RevisionNote;